"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const ReportContext_1 = require("./ReportContext");
class ReportingContext {
    constructor(options) {
        this.servicesProvider = options.serviceProvider;
        this._reportDefinitionsService = options.reportDefinitionsService;
        this._dataflowMiddlewares = options.dataflowMiddlewares;
        this._componentContextsMiddlewares = options.componentContextsMiddlewares;
    }
    getReportContext(reportId) {
        return __awaiter(this, void 0, void 0, function* () {
            const definition = yield this._reportDefinitionsService.getDefinition(reportId);
            if (definition === undefined) {
                throw new Error(`Report definition ${reportId} does not exist`);
            }
            const reportOptions = {
                definition: definition,
                serviceProvider: this.servicesProvider,
                componentsContextsMiddlewares: this._componentContextsMiddlewares,
                dataflowMiddlewares: this._dataflowMiddlewares,
            };
            const context = new ReportContext_1.ReportContext(reportOptions);
            return context;
        });
    }
}
exports.ReportingContext = ReportingContext;
//# sourceMappingURL=ReportingContext.js.map